module.exports = __webpack_public_path__ + "img/step-3.98f08405.jpg";